/**
 * Enum representing different types of devices.
 */
export enum DeviceTypes {
  /**
   * Represents a mobile device.
   */
  mobile = "mobile",

  /**
   * Represents a tablet device.
   */
  tablet = "tablet",

  /**
   * Represents a desktop device.
   */
  desktop = "desktop",

  /**
   * Represents a wide desktop device.
   */
  wideDesktop = "wideDesktop",
}

export enum StatusChipTypes {
  status = "status",
  priority = "priority",
}

export enum Status {
  IN_PROGRESS = "in progress",
  DONE = "done",
  TODO = "todo",
  CANCELLED = "cancelled",
  BACKLOG = "backlog",
  ACTIVE = "Active",
  ON_LEAVE = "On Leave",
}

export enum Priority {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export enum Type {
  DOCUMENT = "document",
  FEATURE = "feature",
  BUG = "bug",
}

export enum ButtonType {
  ICON = "icon",
  TOGGLE = "toggle",
}

export enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  CLEAR = "clear",
  DANGER = "danger",
  DELETE = "delete",
}

export enum ColumnType {
  TEXT = "text",
  BUTTON = "button",
  CHECKBOX = "checkbox",
  IMAGE = "image",
  BUILD_STATUS = "buildStatus",
  COUNTABLE = "countable",
  CUSTOM = "custom",
  STATUS = "status",
  PRIORITY = "priority",
  TYPE = "type",
}

/**
 * Enum representing different types of modals.
 */
export enum ModalType {
  /**
   * Represents a question modal with Yes/No buttons.
   */
  QUESTION = "question",

  /**
   * Represents a modal that can render any custom component.
   */
  COMPONENT = "component",

  /**
   * Represents an informational modal with a close button.
   */
  INFO = "info",

  /**
   * Represents a confirmation modal with Confirm/Cancel buttons.
   */
  CONFIRM = "confirm",
}

/**
 * Enum to represent chat type
 */
export enum ChatType {
  QNA = "QNA",
  ClinicalCase = "ClinicalCase",
}

// Enums for tab values
export enum TabValue {
  LATEST_UPDATES = "latest_updates",
  GUIDELINES = "guidelines",
  TREATMENT_OPTIONS = "treatment_options",
  CONGRESS = "congress",
  DRUGS = "drugs",
  MEDIA = "media",
  DIAGNOSTIC_TOOLS = "diagnostic_tools",
  LATEST_INNOVATIONS = "latest_innovations",
  MEDICAL_JOB_OPPORTUNITIES = "medical_job_opportunities",
  DISEASES = "diseases",
  LABORATORY_VALUES = "laboratory_values",
  MEDICAL_CALCULATORS = "medical_calculators",
  CLINICAL_CASES = "clinical_cases",
  MEDICAL_REPORTS = "medical_reports",
  MONITORING_DISEASE_PROGRESSION = "monitoringـdisease_progression",
}

// Enum for filter names
export enum FilterName {
  SUB_SPECIALTY = "SubSpecialty",
  TYPE_OF_STUDIES_AND_RESEARCH = "TypeOfStudiesAndResearch",
  PUBLISHER = "publisher",
  DATE = "date",
  CONGRESSES = "congresses",
  LETTERS = "letters",
  CONTINENT = "continent",
  RESOURCE = "resource",
}

// Enum for filter keys
export enum FilterKey {
  SUBSPECIALTY_ID = "subspecialty_id",
  TYPE_OF_STUDY_ID = "type_of_study_id",
  PUBLISHER = "publisher",
  DATE = "date",
  CONGRESS_ID = "congress_id",
  LETTER_ID = "letter_id",
  CONTINENT_ID = "continent_id",
  RESOURCE_ID = "resource_id",
}

export enum TabId {
  DRUGS = 5,
  DISEASES = 10,
}

export enum FormComponent {
  Input = "InputField",
  Select = "SelectField",
  DatePicker = "DatePickerField",
  Range = "RangeField",
  Checkbox = "CheckboxField",
  Textarea = "TextareaField",
  SearchableSelect = "SearchableSelect",
  RadioField = "RadioField",
  Display = "DisplayField",
  ImageUploader = "ImageUploader",
}

export enum MedicationStatus {
  ACTIVE = "active",
  DISCONTINUED = "discontinued",
  COMPLETED = "completed",
}

export enum VisitType {}
// ... existing code ...
